import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpAdvisorRetentionKeys = {
  all: ['analytics', 'fp-advisor-retention'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpAdvisorRetentionKeys.all, 'list', params] as const,
};

export const useFPAdvisorRetentionData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpAdvisorRetentionKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPAdvisorRetention(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
